import type { BotWizardConfig } from './types';

export const botWizardConfig: BotWizardConfig = {
	annals: {
		firstStep: 'generate_bot_gender_and_style',
		presetSteps: [
			'generate_bot_age_and_ethnic_background',
			'generate_bot_body',
			'generate_bot_face',
			'generate_bot_personality',
			'generate_bot_name_and_sexual_orientation',
			'generate_bot_chat_style',
			'generate_bot_occupation',
			'generate_bot_starting_relationship',
			'generate_bot_kinks',
		],
	},
	fields: {
		gender: {
			required: true,
			queryKey: 'g',
			previewTitle: 'Gender',
			type: 'button',
		},
		style: {
			required: true,
			queryKey: 's',
			previewTitle: 'Style',
			type: 'image',
			layout: {
				type: 'wrap',
				option: 1,
				aspectRatio: 'square',
				desktopAspectRatio: 'vertical',
			},
		},
		age: {
			required: true,
			queryKey: 'a',
			previewTitle: 'Age',
			type: 'button',
			allowCustom: true,
			isAgeCustom: true,
		},
		ethnic: {
			required: true,
			queryKey: 'e',
			previewTitle: 'Ethnic',
			type: 'image',
			layout: { type: 'wrap', option: 2 },
		},
		height: {
			required: true,
			queryKey: 'h',
			previewTitle: 'Height',
			type: 'button',
		},
		physique: {
			required: true,
			queryKey: 'p',
			previewTitle: 'Physique',
			type: 'image',
			layout: { type: 'carousel' },
		},
		boobs: {
			required: true,
			queryKey: 'b',
			previewTitle: 'Boobs',
			layout: { type: 'carousel' },
			type: 'image',
		},
		butt: {
			required: true,
			queryKey: 'bu',
			previewTitle: 'Butt',
			type: 'image',
			layout: { type: 'carousel' },
		},
		penisSize: {
			required: true,
			queryKey: 'pe',
			previewTitle: 'Penis',
			type: 'image',
			layout: { type: 'carousel' },
		},
		hairStyle: {
			required: true,
			queryKey: 'ha',
			previewTitle: 'Hair',
			type: 'image',
			layout: { type: 'wrap', option: 6, aspectRatio: 'vertical' },
		},
		hairColor: {
			required: true,
			queryKey: 'hac',
			previewTitle: 'Hair color',
			type: 'color',
			data: [
				{
					value: '#C9B991',
					id: 'beige',
				},
				{
					value: '#000000',
					id: 'black',
				},
				{
					value: '#271913',
					id: 'brunette',
				},
				{
					value: '#B83E17',
					id: 'orange',
				},
				{
					value: '#7F7F7F',
					id: 'grey',
				},
				{
					value: '#D9D9D9',
					id: 'blond',
				},
				{
					value: '#B11313',
					id: 'red',
				},
				{
					value: '#219D62',
					id: 'green',
				},
				{
					value: '#0D7EE7',
					id: 'blue',
				},
				{
					value: '#ED49A1',
					id: 'pink',
				},
				{
					value: '#58CDDA',
					id: 'turquoise',
				},
				{
					value: '#F4C03C',
					id: 'yellow',
				},
			],
		},
		eyeColor: {
			required: true,
			queryKey: 'ey',
			previewTitle: 'Eye color',
			layout: { type: 'carousel', option: 1 },
			type: 'image',
		},
		personality: {
			type: 'sliders',
			previewTitle: 'Personality',
			queryKey: 'pers',
		},
		name: {
			type: 'text',
			previewTitle: 'Name',
			queryKey: 'n',
		},
		orientation: {
			required: true,
			queryKey: 'or',
			previewTitle: 'Sexual orientation',
			type: 'image',
			layout: {
				type: 'wrap',
				option: 3,
				aspectRatio: 'square',
				desktopAspectRatio: 'horizontal',
			},
		},
		chatStyle: {
			required: true,
			queryKey: 'cs',
			withExample: true,
			previewTitle: 'Chat style',
			layout: {
				type: 'wrap',
				option: 4,
				aspectRatio: 'square',
			},
			type: 'image',
		},
		occupation: {
			queryKey: 'oc',
			type: 'image',
			allowCustom: true,
			previewTitle: 'Occupation',
			layout: {
				type: 'wrap',
				option: 5,
				aspectRatio: 'vertical',
				desktopAspectRatio: 'vertical',
			},
		},
		startingRelationship: {
			queryKey: 'sr',
			type: 'button',
			previewTitle: 'Starting relationship',
			image: '/assets/botWizard/startRelationship.png',
			allowCustom: true,
		},
		kinks: {
			previewTitle: 'Kinks',
			queryKey: 'knk',
			type: 'button',
			withSearch: true,
			multiSelect: true,
		},
	},
};
